import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  CancelButton,
  SendButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { sendNotification } from "../../../../../redux/features/appraisalSlice";
import useHandleApiResponse from "../../../../../Hooks/useHandleApiResponse";

const Notify = ({ title, id }) => {
  const handleApiResponse = useHandleApiResponse();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.appraisal);
  const [open, setOpen] = useState(false);

  const handleSend = () => {
    const data = {
      cycleId: id,
      type: title === "Self Appraisal Status" ? 1 : 2,
    };
    dispatch(sendNotification(data)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
        },
        onFailed: () => {
          console.log("Something went wrong");
        },
      });
    });
  };
  return (
    <Box>
      <GlobalDialog
        title={"Send Reminder"}
        open={open}
        setOpen={setOpen}
        closeButton={true}
        popupButton={
          <Button onClick={() => setOpen(true)} size="small" variant="outlined">
            Notify
          </Button>
        }
        content={
          <Box>
            <Typography>Are you sure ? you want to send reminder..!</Typography>
          </Box>
        }
        actionButton={
          <>
            <CancelButton size={"small"} action={() => setOpen(false)}>
              Cancel
            </CancelButton>
            <SendButton disabled={loading} action={handleSend} size={"small"}>
              {loading ? "Please wait..." : "Send"}
            </SendButton>
          </>
        }
      />
    </Box>
  );
};

export default Notify;
